import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MpModalController } from '../../../core/overlay/mp-modal.controller';

/**
 * Janela que o crédito "Desenvolvido com ❤️ pela Multipedidos" abre ao ser tocado.
 *
 * Antes o toque levava direto ao onboarding, e muita gente que tocava era
 * consumidor perdido, no fim do acompanhamento do pedido. A janela diz o que é a
 * Multipedidos e dá os dois caminhos: conhecer (o onboarding, em outra aba) ou
 * voltar ao pedido.
 *
 * A contagem fica toda no crédito: aqui só se avisa a escolha (`aoQuerer`) e se
 * fecha com o papel dela (`cta` | `voltar`).
 */
@Component({
	selector: 'app-multipedidos-credit-dialog',
	standalone: true,
	imports: [TranslateModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<!-- A fonte do layout novo nos dois layouts: a janela é da Multipedidos, não da loja. -->
		<div class="multipedidos-credit-dialog new-design-font" data-cy="mpCreditDialog">
			<p class="multipedidos-credit-dialog__title">{{ 'About Multipedidos' | translate }}</p>
			<p class="multipedidos-credit-dialog__text">
				{{ 'Multipedidos is the platform behind this digital menu. Your order is placed directly with the store, and the store takes care of it.' | translate }}
			</p>
			<p class="multipedidos-credit-dialog__text">
				{{ 'Own a restaurant or another business? With Multipedidos you can sell through your own digital menu too.' | translate }}
			</p>
			<div class="multipedidos-credit-dialog__actions">
				<a class="multipedidos-credit-dialog__btn multipedidos-credit-dialog__btn--primary"
					[href]="href" target="_blank" rel="noopener" data-cy="mpCreditDialogCta" (click)="querer()">
					{{ 'I want a digital menu and much more' | translate }}&nbsp;<span aria-hidden="true">→</span>
				</a>
				<button type="button" class="multipedidos-credit-dialog__btn multipedidos-credit-dialog__btn--secondary"
					data-cy="mpCreditDialogBack" (click)="voltar()">
					{{ 'Back to my order' | translate }}
				</button>
			</div>
		</div>
	`,
	styleUrls: ['./multipedidos-credit-dialog.component.scss'],
})
export class MultipedidosCreditDialogComponent {
	/** O onboarding com os UTMs da tela: o mesmo `href` do crédito (`componentProps`). */
	href = '';

	/** Chamado no toque do botão do onboarding, antes de a outra aba abrir: é ali que sai o beacon. */
	aoQuerer: () => void = () => {};

	constructor(private modalCtrl: MpModalController) {}

	/**
	 * Fecha sem cancelar o link: o `<a href>` abre a outra aba depois deste
	 * handler, e a janela só sai da tela ao fim da animação.
	 */
	querer(): void {
		try {
			this.aoQuerer();
		} catch (e) {
			// telemetria nunca segura o link
		}
		this.modalCtrl.dismiss(undefined, 'cta');
	}

	voltar(): void {
		this.modalCtrl.dismiss(undefined, 'voltar');
	}
}
